import React from 'react'
import StarIcon from '@mui/icons-material/Star';
import RealEstateAgentIcon from '@mui/icons-material/RealEstateAgent';
import FactoryIcon from '@mui/icons-material/Factory';
import LocalMallIcon from '@mui/icons-material/LocalMall';

export default function Achivment() {
    const stats = [
    { value: <RealEstateAgentIcon/> , label: "Real Estate" },
    { value: <FactoryIcon/>, label: "Manufacturing" },
    { value: <LocalMallIcon/>, label: "FMCG" },
    { value: <StarIcon/>, label: "Pharma" },
    { value: <StarIcon/>, label: "Startups" },
    { value: <StarIcon/>, label: "Infrastructure" },
  ];
 
  return (
     <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-20 px-4">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-1 gap-12 items-center">

        {/* LEFT */}
        <div className="animate-fadeInUp">
          <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
            Industries We Serve
          </h4>
          <p className='pb-10 max-w-3xl'>We deliver tailored financial solutions across diverse industries, helping businesses streamline operations, improve cash flow, and accelerate growth with confidence</p>

          <div className="grid grid-cols-6 gap-8">
            {stats.map((item, index) => (
              <div key={index} className="flex gap-4 animate-fadeUp"
                   style={{ animationDelay: `${index * 0.2}s` }}>
                <div className="w-[2px] bg-gradient-to-b from-[#00bd86] to-transparent"></div>

                <div>
                  <h2 className="text-2xl sm:text-3xl font-bold text-[#1e3a8a]">
                    {item.value}
                  </h2>
                  <p className="text-gray-600 text-sm sm:text-base">
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT */}
       
      </div>

      {/* ANIMATIONS */}
      <style>{`
        @keyframes fadeInUp {
          from {opacity:0; transform:translateY(40px);}
          to {opacity:1; transform:translateY(0);}
        }

        @keyframes fadeUp {
          from {opacity:0; transform:translateY(30px);}
          to {opacity:1; transform:translateY(0);}
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease forwards;
        }

        .animate-fadeUp {
          opacity: 0;
          animation: fadeUp 0.8s ease forwards;
        }
      `}</style>
    </section>
  )
}
